export enum MessageType {
  Neutral,
  Info,
  Success,
  Warning,
  Danger
}
